// import * as $ from 'jquery';

import {
  Inject,
  NgModule,
  Provider
} from '@angular/core'
import { BrowserModule, Title } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { startCase, toLower } from 'lodash';
import { ROLLBAR_ERROR_HANDLER } from './rollbar/rollbar-error-handler';
import {
  APP,
  HubComponentsModule,
  SESSION_SERVICE_APP_INITIALIZER,
  ObjectBaseService,
  SharedObjectBaseService,
} from '@hub-components';
import { RollbarServiceToken, rollbarFactory } from './rollbar/rollbar.config';
import { AppComponent } from './app.component'
import { AppRouterModule } from './app-routing.module'
import { FallbackComponent } from './fallback.component'
import { DashboardsService } from './apps/studio/app/services/dashboards.service';
import { SharedDashboardsService } from './apps/studio/app/services/shared-dashboards.service';
import { ReportsService } from './apps/reports/app/services/reports.service';
import { DiscoveriesService } from './apps/discovery/app/services/discoveries/discoveries.service';
import { SharedReportsService } from './apps/reports/app/services/shared-reports.service';
import { SharedDiscoveriesService } from './apps/discovery/app/services/shared-discoveries/shared-discoveries.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SnapshotService } from './apps/snapshot/app/services/snapshot/snapshot.service';

declare var location: Location
export function appName() {
  return location.hostname.split('.', 2)[0].replace(/-u$/, '').replace(/-/g, '_')
}

const COMPONENTS = [
  AppComponent
]

export const PROVIDERS: Provider[] = [
  { provide: APP, useFactory: appName },
  { provide: RollbarServiceToken, useFactory: rollbarFactory },
  ROLLBAR_ERROR_HANDLER,
  SESSION_SERVICE_APP_INITIALIZER
]

const MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  AngularSvgIconModule.forRoot(),
  HubComponentsModule.forRoot(),
]

/**
 * This is an alternative to the provide and useclass override per app.module
 * After migration it stopped working as it needs to be done from the root app.
 */
addProvidersPerApp(appName());

@NgModule({
  declarations: [
    FallbackComponent,
    COMPONENTS
  ],
  imports: [
    MODULES,
    AppRouterModule,
    BrowserAnimationsModule,
  ],
  providers: PROVIDERS,
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(@Inject(APP) app, title: Title) {
    title.setTitle(startCase(toLower(app)));
  }
}

function addProvidersPerApp(appName) {
  switch (appName) {
    case 'studio':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: DashboardsService },
        { provide: SharedObjectBaseService, useClass: SharedDashboardsService },
      )
      break;
    case 'reports':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: ReportsService },
        { provide: SharedObjectBaseService, useClass: SharedReportsService },
      )
      break;
    case 'discovery':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: DiscoveriesService },
        { provide: SharedObjectBaseService, useClass: SharedDiscoveriesService },
      )
      break;
    case 'snapshot':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: SnapshotService },
      );
      break;
    default:
      break;
  }
}
